

// assets/js/custom-link-extensions.js
const { InspectorControls } = wp.blockEditor;
const { SelectControl, TextControl } = wp.components;
const { addFilter } = wp.hooks;
const { createElement } = wp.element;

// 1. Filter the block's registration to add the attributes.
addFilter(
  "blocks.registerBlockType",
  "innicio/add-navigation-link-attributes",
  (settings, name) => {
    if (name === "core/navigation-link") {
      return Object.assign({}, settings, {
        attributes: Object.assign({}, settings.attributes, {
          linkIcon: {
            type: "string",
            default: "",
          },
        }),
      });
    }
    return settings;
  }
);

// 2. Filter the save function to add the custom HTML.
addFilter(
  "blocks.getSaveContent.extraProps",
  "innicio/add-navigation-link-save",
  (extraProps, blockType, attributes) => {
    console.log("add-navigation-link-save");
    if (blockType.name === "core/navigation-link") {
      const { linkIcon } = attributes;

      if (linkIcon) {
        extraProps.className = `${extraProps.className || ""} ${linkIcon}`;
      }
    }
    return extraProps;
  }
);

addFilter(
  "blocks.getSaveContent.extraProps",
  "innicio/add-navigation-link-editor-styles",
  (extraProps, blockType, attributes) => {
    console.log("add-navigation-link-editor-styles");
    if (blockType.name === "core/navigation-link") {
      const { linkIcon } = attributes;

      if (linkIcon) {
        extraProps.className = `${extraProps.className || ""} ${linkIcon}`;
      }
    }
    return extraProps;
  }
);

// Your existing filter for BlockEdit.
addFilter(
  "editor.BlockEdit",
  "innicio/add-navigation-link-controls",
  (BlockEdit) => {
    return (props) => {
      if (props.name !== "core/navigation-link") {
        return <BlockEdit {...props} />;
      }

      const { attributes, setAttributes } = props;
      const iconList = [
        { label: "innicio-bolt", value: "dashicons-innicio-bolt" },
        { label: "home-heart", value: "dashicons-innicio-home-heart" },
        { label: "translate", value: "dashicons-innicio-translate" },
        { label: "star", value: "dashicons-innicio-star" },
        { label: "x", value: "dashicons-innicio-x" },
        { label: "check", value: "dashicons-innicio-check" },
      ];
      const handleClick = (linkIcon) => {
        setAttributes({ linkIcon: linkIcon });
      };
      return (
        <>
          <BlockEdit {...props} />
          <InspectorControls>
            <div
              style={{
                marginBottom: "20px",
                border: "1px dotted grey",
                padding: "10px",
              }}
            >
              <span
                className={`dashicon dashicons dashicons-remove`}
                onClick={() => handleClick("")}
                style={{
                  cursor: "pointer",
                  marginRight: "10px",
                  display: "inline-block",
                }} // Optional styling
              ></span>
              {iconList.map((icon, index) => (
                <span
                  key={index}
                  style={{
                    display: "inline-block",
                    padding: "10px",
                    backgroundColor: `${
                      attributes.linkIcon == icon.value ? "black" : ""
                    }`,
                  }}
                >
                  <span
                    key={index}
                    className={`dashicon dashicons ${icon.value} ${
                      attributes.linkIcon == icon.value ? "selected" : ""
                    }`}
                    onClick={() => handleClick(icon.value)}
                    style={{ cursor: "pointer", display: "inline-block" }} // Optional styling
                  ></span>
                </span>
              ))}
            </div>

            <SelectControl
              label="Icon Class"
              value={attributes.linkIcon}
              options={[{ label: "Default", value: "" }, ...iconList]}
              onChange={(newValue) => setAttributes({ linkIcon: newValue })}
            />
          </InspectorControls>
        </>
      );
    };
  }
);
